import React from 'react'
import { Trans } from 'react-i18next/icu.macro'
import { Link } from '@fs/zion-router'
import { i18n } from '@fs/zion-locale'
import { useTranslation } from 'react-i18next'
import errorImg from '../assets/permissionError.svg'
import CreateError from './CreateError'

export default function PermissionError() {
  const [t] = useTranslation()
  const errorInfo = {
    heading: t('centers.permission-required', 'You need permission to view this page'),
    image: errorImg,
    trans: (
      <Trans
        i18nKey="centers.permission-required.fix"
        defaults="If you believe you should have access, contact your stake clerk to make sure your calling is entered correctly. If it still isn't working, please <SupportLink>contact support</SupportLink> for assistance."
        components={{
          SupportLink: (
            <Link
              to={`https://www.familysearch.org/${i18n.language}/fieldops/familysearch-support-contact-us`}
              external
            />
          ),
        }}
      />
    ),
  }

  return <CreateError errorInfo={errorInfo} />
}
